import { TextMessageSourceActions } from "../../types/abstract/text_message_source.types.abstract";
import { ITextMessageSource } from "atlas-shared";
import { getTextMessageSources } from "@Api";

export const actionFetchTextMessageSources = () => {
  return async (dispatch) => {
    dispatch(actionLoadingTextMessageSources());
    const text_message_sources = await getTextMessageSources();

    dispatch(actionSetTextMessageSources(text_message_sources));
    return text_message_sources;
  };
};

export const actionLoadingTextMessageSources = () => ({
  type: TextMessageSourceActions.LOADING,
  payload: [],
});

export const actionSetTextMessageSources = (payload: Array<ITextMessageSource>) => ({
  type: TextMessageSourceActions.SET_STATE,
  payload: payload,
});

export const actionAddTextMessageSources = (payload: ITextMessageSource) => ({
  type: TextMessageSourceActions.ADD_STATE,
  payload: payload,
});

export const actionUpdateTextMessageSources = (payload: ITextMessageSource) => ({
  type: TextMessageSourceActions.UPDATE_STATE,
  payload: payload,
});
